import { useState, useEffect } from "react";

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const useTypewriter = ({
  from,
  to,
  active,
  delay = 0,
  deleteSpeed = 30,
  typeSpeed = 35,
  pauseMs = 200,
}: {
  from: string;
  to: string;
  active: boolean;
  delay?: number;
  deleteSpeed?: number;
  typeSpeed?: number;
  pauseMs?: number;
}) => {
  const [text, setText] = useState(from);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    if (!active) return;

    setText(from);
    setIsDone(false);
    setIsAnimating(true);
    let cancelled = false;

    const run = async () => {
      if (delay > 0) await sleep(delay);
      if (cancelled) return;

      // Delete phase
      for (let i = from.length; i >= 0; i--) {
        if (cancelled) return;
        setText(from.slice(0, i));
        await sleep(deleteSpeed);
      }

      // Pause
      if (cancelled) return;
      await sleep(pauseMs);

      // Type phase
      for (let i = 0; i <= to.length; i++) {
        if (cancelled) return;
        setText(to.slice(0, i));
        await sleep(typeSpeed);
      }

      if (cancelled) return;
      setIsAnimating(false);
      setIsDone(true);
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [active, from, to, delay, deleteSpeed, typeSpeed, pauseMs]);

  return { text, isAnimating, isDone };
};
